<template>
    <div>
        <p class="text-color-gray mb10">{{tip}}</p>
        <div class="batch-content">
            <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="input"
                :rows="10"
                resize="none"
                style="min-height: 200px;"
                :autofocus="true"
            >
            </el-input>
        </div>
        <p class="tac mt20">
            <el-button type="default" @click="$emit('close')" class="mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="hasLoading && loading" class="ml20">提交
            </el-button>
        </p>
    </div>
</template>

<script>
export default {
    name: 'BatchSelectModal',
    props: {
        tip: {
            type: String,
            required: true
        },
        hasLoading: {
            type: Boolean,
            default: false
        },
        cbs: {
            type: Object
        }
    },
    data() {
        return {
            input: '',
            loading: false
        }
    },
    methods: {
        async handleSubmit() {
            let data = this.input.split(/\n/).map(item=>item.trim()).filter(item=>!!item);
            if (this.hasLoading) {
                this.loading = true
                this.cbs.onSubmit(data, ()=> {
                    this.loading = false
                })
            }else {
                try {
                    this.loading = true
                    await this.cbs.onSubmit(data)
                } catch (error) {
                    return Promise.reject(error)
                }finally {
                    this.loading = false
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>